module.exports = __webpack_public_path__ + "static/media/check.d5dffde8.png";